import * as storage from './storage';
import base64url from 'base64url';

export const JWT_AVATAR_CLAIM = 'avatarUrl';
export const JWT_USERNAME_CLAIM = 'userName';
export const JWT_EMAIL_CLAIM = 'emailAddress';

export const requiredAuthKeys = [
  storage.AUTH_TOKEN,
  storage.USER_KEY,
  storage.EMAIL_KEY,
  storage.AVATAR_URL_LARGE
];

export const getAuthToken = () => {
  return localStorage.getItem(storage.AUTH_TOKEN);
};

const decodePayload = (authToken) => {
  const firstIndex = authToken.indexOf('.');
  const secondIndex = authToken.indexOf('.', firstIndex + 1);
  const base64UrlData = authToken.slice(firstIndex + 1, secondIndex);
  return JSON.parse(base64url.decode(base64UrlData));
};

/**
 * Whether a dashboard jwt has passed its expiry (exp claim, in seconds).
 * Tokens without a readable expiry are left for the backend to reject.
 * @param {string} authToken : the dashboard jwt
 * @returns true if the token can no longer be used
 */
export const isTokenExpired = (authToken) => {
  try {
    const { exp } = decodePayload(authToken);
    return !!exp && exp * 1000 <= Date.now();
  } catch (error) {
    return false;
  }
};

export const checkAuthenticated = () => {
  const isAuthenticated = requiredAuthKeys.every(k => !!localStorage.getItem(k)) &&
    !isTokenExpired(getAuthToken());

  // cleans up any leftover storage values
  if (!isAuthenticated) removeAuthentication();
  return isAuthenticated;
};

export const storePayloadData = (authToken) => {
  const data = decodePayload(authToken);

  localStorage.setItem(storage.AUTH_TOKEN, authToken);
  localStorage.setItem(storage.AVATAR_URL_LARGE, data[JWT_AVATAR_CLAIM]);
  localStorage.setItem(storage.USER_KEY, data[JWT_USERNAME_CLAIM]);
  localStorage.setItem(storage.EMAIL_KEY, data[JWT_EMAIL_CLAIM]);
};

// remove requiredKeys + authKey in case user's first time using new token auth
export const removeAuthentication = () =>
  [...requiredAuthKeys, storage.AUTH_KEY].forEach(k => localStorage.removeItem(k));



// WEBPACK FOOTER //
// src/helpers/auth.js